module.exports = __webpack_public_path__ + "static/img/dialog2.715f78c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4/dialog2.png
// module id = 0O4Y
// module chunks = 7